import { calcStreak } from "../utils/helpers";

export const ALL_ACHIEVEMENTS = [
  // ── First steps ─────────────────────────────────────────────────────────
  { id: "first_lift",      emoji: "🏋️", name: "First Lift",        desc: "Complete your first workout",         check: ({ totalWorkouts })  => totalWorkouts >= 1 },
  { id: "first_run",       emoji: "🏃", name: "First Run",         desc: "Log your first run",                  check: ({ totalRuns })       => totalRuns >= 1 },
  { id: "first_pr",        emoji: "🏅", name: "First PR",          desc: "Set your first personal record",      check: ({ prCount })         => prCount >= 1 },

  // ── Activity volume ──────────────────────────────────────────────────────
  { id: "five_workouts",   emoji: "💥", name: "Getting Serious",   desc: "Complete 5 workouts",                 check: ({ totalWorkouts })  => totalWorkouts >= 5 },
  { id: "twenty_workouts", emoji: "🐀", name: "Gym Rat",           desc: "Complete 20 workouts",                check: ({ totalWorkouts })  => totalWorkouts >= 20 },
  { id: "fifty_workouts",  emoji: "⛏️", name: "Iron Devotion",     desc: "Complete 50 workouts",                check: ({ totalWorkouts })  => totalWorkouts >= 50 },
  { id: "ten_club",        emoji: "💪", name: "10 Club",           desc: "Log 10 total activities",             check: ({ totalActivity })  => totalActivity >= 10 },
  { id: "half_century",    emoji: "🔥", name: "Half Century",      desc: "Log 50 total activities",             check: ({ totalActivity })  => totalActivity >= 50 },
  { id: "century_club",    emoji: "👑", name: "Century Club",      desc: "Log 100 total activities",            check: ({ totalActivity })  => totalActivity >= 100 },

  // ── Running ──────────────────────────────────────────────────────────────
  { id: "five_runs",       emoji: "👟", name: "Runner",            desc: "Log 5 runs",                          check: ({ totalRuns })       => totalRuns >= 5 },
  { id: "twenty_runs",     emoji: "🛣️", name: "Road Warrior",      desc: "Log 20 runs",                         check: ({ totalRuns })       => totalRuns >= 20 },
  { id: "fifty_runs",      emoji: "🗺️", name: "Miles & Miles",     desc: "Log 50 runs",                         check: ({ totalRuns })       => totalRuns >= 50 },

  // ── Streaks ──────────────────────────────────────────────────────────────
  { id: "week_warrior",    emoji: "📅", name: "Week Warrior",      desc: "7-day streak",                        check: ({ currentStreak })  => currentStreak >= 7 },
  { id: "two_week",        emoji: "🗓️", name: "Two Week Grind",    desc: "14-day streak",                       check: ({ currentStreak })  => currentStreak >= 14 },
  { id: "month_savage",    emoji: "🌙", name: "Month Savage",      desc: "30-day streak",                       check: ({ currentStreak })  => currentStreak >= 30 },
  { id: "sixty_streak",    emoji: "🚀", name: "Unstoppable",       desc: "60-day streak",                       check: ({ currentStreak })  => currentStreak >= 60 },
  { id: "hundred_streak",  emoji: "💎", name: "Hundred Days",      desc: "100-day streak",                      check: ({ currentStreak })  => currentStreak >= 100 },

  // ── Personal records ─────────────────────────────────────────────────────
  { id: "five_prs",        emoji: "📈", name: "PR Machine",        desc: "Set 5 personal records",              check: ({ prCount })         => prCount >= 5 },
  { id: "ten_prs",         emoji: "🎯", name: "Always Improving",  desc: "Set 10 personal records",             check: ({ prCount })         => prCount >= 10 },
  { id: "twenty_prs",      emoji: "⭐", name: "Elite Standard",    desc: "Set 20 personal records",             check: ({ prCount })         => prCount >= 20 },
];

export function useGamification(workouts, runs, mealLog, personalRecords) {
  const currentStreak = calcStreak(workouts, runs, mealLog);
  const totalWorkouts = workouts.length;
  const totalRuns = runs.length;
  const totalActivity = totalWorkouts + totalRuns;
  const prCount = Object.keys(personalRecords).length;

  const userLevel =
    totalActivity < 10  ? "Rookie"
    : totalActivity < 25  ? "Regular"
    : totalActivity < 50  ? "Athlete"
    : totalActivity < 100 ? "Beast"
    : "Legend";

  const levelProgress =
    totalActivity < 10  ? (totalActivity / 10) * 100
    : totalActivity < 25  ? ((totalActivity - 10) / 15) * 100
    : totalActivity < 50  ? ((totalActivity - 25) / 25) * 100
    : totalActivity < 100 ? ((totalActivity - 50) / 50) * 100
    : 100;

  const ctx = { totalWorkouts, totalRuns, totalActivity, currentStreak, prCount };

  const achievements = ALL_ACHIEVEMENTS.map((a) => ({
    ...a,
    unlocked: a.check(ctx),
  }));

  return { currentStreak, userLevel, levelProgress, achievements };
}
